import type { GDSStatus } from '@leagueplatform/genesis-core';
import { EntityStatus } from '../types/schemas';

interface EntityStatusBadge {
  genesisStatus: GDSStatus;
  labelKey: string;
}

const defaultStatus: EntityStatusBadge = {
  genesisStatus: 'neutral',
  labelKey: 'DEFAULT',
};

export const entityStatusToGenesisStatusMap: Record<
  EntityStatus,
  EntityStatusBadge
> = {
  published: { genesisStatus: 'success', labelKey: 'PUBLISHED' },
  archived: { genesisStatus: 'error', labelKey: 'ARCHIVED' },
  draft: { genesisStatus: 'info', labelKey: 'DRAFT' },
  new: { genesisStatus: 'neutral', labelKey: 'NEW' },
  default: defaultStatus,
};

export const getEntityStatusBadgeProps = (status?: EntityStatus | string) =>
  entityStatusToGenesisStatusMap[status as EntityStatus] ?? defaultStatus;
